import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import css from './assets/css/main.css'
import VueLazyload from 'vue-lazyload'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faHeart, faHashtag, faSearch, faLock, faEye, faArrowLeft, faPenSquare, faTimes, faCog, faTrashAlt, faCopy, faFileExport, faExternalLinkAlt, faListUl, faTools, faCloudUploadAlt, faCloudDownloadAlt, faEdit, faArchive, faSave, faSpinner, faFolderOpen } from '@fortawesome/free-solid-svg-icons'
import TextareaAutosize from 'vue-textarea-autosize'

Vue.use(TextareaAutosize)
library.add(faHeart, faHashtag, faSearch, faLock, faEye, faArrowLeft, faPenSquare, faTimes, faCog, faTrashAlt, faCopy, faFileExport, faExternalLinkAlt, faListUl, faTools, faCloudUploadAlt, faCloudDownloadAlt, faEdit, faArchive, faSave, faSpinner, faFolderOpen)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueLazyload)

Vue.config.productionTip = false

import {Mixin} from '@/mixins'
import {gdMixin} from '@/mixins/gdrive'

Vue.mixin(Mixin)
Vue.mixin(gdMixin)

new Vue({
  router,
  store,
  css,
  render: h => h(App)
}).$mount('#app')
